import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useSnackbar } from 'notistack';

export default function GlobalToaster() {
  const { message, variant } = useSelector(state => state.toaster);
  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    if (message !== '' && variant !== '') {
      enqueueSnackbar(message, {
        variant
      });
    }
  }, [enqueueSnackbar, message, variant]);
  return <></>;
}
